<template>
    <header id="header-wrapper" class="bg-light py-2 container-fluid text-center d-flex flex-row justify-content-around">
        <h4 class="my-auto">Audio slicer fun!</h4>
        <p class="my-auto text-muted">
            <small>Create weighted combinations of multiple onset detection functions for different segmentation results.</small>
        </p>
    </header>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    // #header-wrapper {
    //     position: absolute;
    //     top: 0vh;
    // }
</style>